import Sockette from "sockette";
import { WSS_URL } from "./util/app";
import AuthProvider from "./providers/Auth.Provider";
import { handleNewData } from "./event/event-resolver";

const staff = AuthProvider.authProvider.GetAuthenticatedStaff();
let ws = undefined;
export const initSocket = () => {
    if (staff) {
        ws = new Sockette(`${WSS_URL}?site=${staff.site.id}`, {
            timeout: 5e3,
            maxAttempts: 1,
            onopen: (e) => console.log("connected:", e),
            onmessage: (e) => handleNewData(e.data),
            onreconnect: (e) => console.log("Reconnecting...", e),
            onmaximum: (e) => console.log("Stop Attempting!", e),
            onclose: (e) => console.log("Closed!", e),
            onerror: (e) => console.log("Error:", e),
        });
    }
};

/**
 *
 * @param {Object} data Updated new data
 * @param {string} _action action example CREATE, UPDATE, or DELETE
 * @param {string} _target target example PATIENT, STAFF etc
 */
export const sendNotification = (data, _action, _target) => {
    if (ws !== undefined)
        ws.json({
            action: "sendNotification",
            data: {
                header: {
                    target: _target,
                    action: _action,
                    site: staff.site.id,
                },
                body: data,
            },
        });
};
